"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultNeighbourhoodInfoState = void 0;
var NeighbourhoodInfo_1 = require("@/pages/place/states/NeighbourhoodInfo");
exports.defaultNeighbourhoodInfoState = {
    groups: [
        {
            name: 'Essentials',
            items: [
                {
                    name: 'Schools',
                    type: NeighbourhoodInfo_1.NeighbourhoodItemType.SCHOOL,
                },
                {
                    name: 'ATM',
                    type: NeighbourhoodInfo_1.NeighbourhoodItemType.ATM,
                },
                {
                    name: 'Pharmacy',
                    type: NeighbourhoodInfo_1.NeighbourhoodItemType.PHARMACY,
                },
            ],
        },
        {
            name: 'Commute',
            items: [
                {
                    name: 'Bus Stop',
                    type: NeighbourhoodInfo_1.NeighbourhoodItemType.BUS_STATION,
                },
                {
                    name: 'MTR Stations',
                    type: NeighbourhoodInfo_1.NeighbourhoodItemType.SUBWAY_STATION,
                },
            ],
        },
        {
            name: 'Food & Lifestyle',
            items: [
                {
                    name: 'Restaurants',
                    type: NeighbourhoodInfo_1.NeighbourhoodItemType.CAFE,
                },
                {
                    name: 'Convenience Store',
                    type: NeighbourhoodInfo_1.NeighbourhoodItemType.CONVENIENCE_STORE,
                },
            ],
        },
        {
            name: 'My Places',
            items: [
                {
                    name: 'My Saved Locations',
                    type: NeighbourhoodInfo_1.NeighbourhoodItemType.PIN,
                },
            ],
        },
    ],
    active: 0,
    mobileActive: false,
    activeType: NeighbourhoodInfo_1.NeighbourhoodItemType.SCHOOL,
    addPlaceActive: false,
};
